export default "__VITE_ASSET__DC9RH4Q3__"